import UsersConfirmationsNew from './UsersConfirmationsNew'

export default UsersConfirmationsNew
